// Unread messages and mentions in my servers, for the server menu's switcher and the dot by the server name (#140).
// Only the open server has a live room, so the others come from GET /api/me/unread: fetched on opening a server, on
// coming back to the tab, and every 30 s while it's visible.
import { useEffect, useState } from "react";
import type { ServerUnread } from "@bloom/shared";
import { api } from "./api.ts";

const EVERY_MS = 30_000;

export function useServerUnread(serverId: string | undefined): ServerUnread {
  const [unread, setUnread] = useState<ServerUnread>({});
  useEffect(() => {
    let live = true;
    const load = () => {
      if (document.visibilityState !== "visible") return;
      api<ServerUnread>("/me/unread").then((u) => live && setUnread(u), () => {});
    };
    load();
    // Again shortly after switching servers: the one I just left may still be taking in what I read there.
    const again = setTimeout(load, 1500);
    const t = setInterval(load, EVERY_MS);
    document.addEventListener("visibilitychange", load);
    window.addEventListener("focus", load);
    return () => {
      live = false;
      clearInterval(t);
      clearTimeout(again);
      document.removeEventListener("visibilitychange", load);
      window.removeEventListener("focus", load);
    };
  }, [serverId]);
  return unread;
}

/** "3 unread mentions", "Unread messages", or "" for nothing: for accessible names. */
export function unreadLabel(u: { unread: boolean; mentions: number } | undefined): string {
  if (!u) return "";
  if (u.mentions > 0) return `${u.mentions} unread mention${u.mentions === 1 ? "" : "s"}`;
  return u.unread ? "unread messages" : "";
}
